import { jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { TypographyVariant } from "./components/TypographyVariant/TypographyVariant.js";
const sections = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "h7",
  "subtitle1",
  "subtitle2",
  "subtitle3",
  "subtitle4",
  "body1",
  "body2",
  "caption",
  "button",
  "overline"
];
function Typography() {
  return /* @__PURE__ */ jsx(Stack, { children: sections.map((section) => /* @__PURE__ */ jsx(TypographyVariant, { section }, section)) });
}
export {
  Typography
};
//# sourceMappingURL=Typography.js.map
